import script from "./TestResult.vue?vue&type=script&setup=true&lang=js"
export * from "./TestResult.vue?vue&type=script&setup=true&lang=js"

import "./TestResult.vue?vue&type=style&index=0&id=2ba9e374&lang=scss&scoped=true"
script.__scopeId = "data-v-2ba9e374"

export default script